import { LegalLayout } from "@/components/legal/LegalLayout";

const IptalIadeKosullariPage = () => (
  <LegalLayout
    title="İptal ve İade Koşulları"
    description="İns Organizasyon hizmetleri için geçerli iptal ve iade süreçleri."
    path="/iptal-iade-kosullari"
  >
    <p>
      İşbu metin, İns Organizasyon Danışmanlık ve Dış Tic. Ltd. Şti. tarafından sunulan saha operasyonu hizmetleri ve bağış
      paketlerine ilişkin iptal ve iade esaslarını düzenler. Tüketici, satın alma işlemini tamamlayarak aşağıdaki koşulları
      kabul etmiş sayılır.
    </p>

    <h2>1. Cayma Hakkı</h2>
    <p>
      Tüketici, hizmetin ifasına başlanmamış olması halinde, sözleşmenin kurulmasından itibaren 14 gün içinde hiçbir gerekçe
      göstermeksizin cayma hakkını kullanabilir. Cayma talebi, info@insorganizasyon.org adresine yazılı olarak iletilmelidir.
    </p>

    <h2>2. Hizmete Başlanmış Olması</h2>
    <p>
      Saha operasyonuna fiilen başlanmış veya üçüncü kişiler lehine edimler yerine getirilmiş ise cayma hakkı, KVKK ve Mesafeli
      Sözleşmeler Yönetmeliği uyarınca sınırlandırılabilir. Bu durumda operasyonun durumu değerlendirilerek iadeye ilişkin karar
      taraflara yazılı olarak bildirilir.
    </p>

    <h2>3. İade Süreci</h2>
    <ul>
      <li>Cayma talebinin onaylanmasından sonra iade ödemesi en geç 14 gün içinde yapılır.</li>
      <li>Ödeme, tüketicinin satın alma sırasında kullandığı ödeme aracına uygun şekilde gerçekleştirilir.</li>
      <li>Banka ve ödeme kuruluşlarından kaynaklanan gecikmelerden Satıcı sorumlu değildir.</li>
    </ul>

    <h2>4. Operasyonel Gecikmeler</h2>
    <p>
      Güvenlik, doğal afet, izin süreçleri veya mücbir sebepler nedeniyle operasyonun yapılamadığı durumlarda, tüketiciye
      bilgilendirme yapılır ve talebine göre iade veya alternatif operasyon önerisi sunulur.
    </p>

    <h2>5. Yetersiz Bilgi / Yanlış Beyan</h2>
    <p>
      Tüketici tarafından sağlanan bilgilerin eksik veya yanlış olması nedeniyle operasyonun gerçekleştirilememesi halinde
      sorumluluk tüketiciye aittir. Bu durumdaki iptal talepleri Satıcı tarafından değerlendirilerek sonuçlandırılır.
    </p>

    <h2>6. İletişim</h2>
    <p>İptal ve iade taleplerinizi aşağıdaki kanallar aracılığıyla iletebilirsiniz:</p>
    <ul>
      <li><strong>E-posta:</strong> info@insorganizasyon.org</li>
      <li><strong>Telefon:</strong> +90 541 587 88 22</li>
      <li><strong>Adres:</strong> Arabacıalanı Mah. Çark Cad. No: 236 Daire 2 Serdivan / Sakarya</li>
    </ul>

    <p>
      Bu metinde yer almayan hususlarda 6502 sayılı Kanun ve ilgili mevzuat hükümleri uygulanır. İns Organizasyon gerekli
      hallerde koşulları güncelleme hakkını saklı tutar.
    </p>
  </LegalLayout>
);

export default IptalIadeKosullariPage;
